import { render } from "./EditingRights.vue?vue&type=template&id=aa5e3688"
import script from "./EditingRights.vue?vue&type=script&lang=js"
export * from "./EditingRights.vue?vue&type=script&lang=js"
script.render = render

export default script